const MAX_VISIBLE_EVENTS = 7
const UNASSIGNED_ID = "unassigned"

const CALENDAR_TABS = {
  ALL_BOOKINGS: "all-bookings",
  MY_BOOKINGS: "my-bookings",
  CREW: "crew",
  EQUIPMENT: "equipment",
}

const DEFAULT_START_HOUR = 0
const DEFAULT_END_HOUR = 23

const WeekDaysLabels = [
  { shortName: "Sun", fullName: "Sunday" },
  { shortName: "Mon", fullName: "Monday" },
  { shortName: "Tue", fullName: "Tuesday" },
  { shortName: "Wed", fullName: "Wednesday" },
  { shortName: "Thu", fullName: "Thursday" },
  { shortName: "Fri", fullName: "Friday" },
  { shortName: "Sat", fullName: "Saturday" }
]

const DEFAULT_RANGE = "month"
const RANGE_OPTIONS = {
  date: "Day",
  week: "Week",
  month: "Month"
}

const TIME_OFF_BE_KEYS = {
  weekDays: "weekdays",
  dateRange: "date_range",
  singleDay: "single_day"
}

const TIME_OFF_WEEKS_COLUMNS = ["Day(s) of the Week", "Time", "Starts on", "Ends on", ""]
const TIME_OFF_DATE_RANGE_COLUMNS = ["Starts on", "Ends on", ""]
const TIME_OFF_SINGLE_DAY_COLUMNS = ["Day Off", "Starts at", "Ends at", ""]

const TIME_OFF_COLUMNS = {
  weekdays: TIME_OFF_WEEKS_COLUMNS,
  date_range: TIME_OFF_DATE_RANGE_COLUMNS,
  single_day: TIME_OFF_SINGLE_DAY_COLUMNS
}

// Single accessor for time-off columns per type
const getTimeOffColumns = (view) => TIME_OFF_COLUMNS[view] || []

export {
  MAX_VISIBLE_EVENTS,
  UNASSIGNED_ID,
  CALENDAR_TABS,
  DEFAULT_START_HOUR,
  DEFAULT_END_HOUR,
  WeekDaysLabels,
  DEFAULT_RANGE,
  RANGE_OPTIONS,
  TIME_OFF_WEEKS_COLUMNS,
  TIME_OFF_DATE_RANGE_COLUMNS,
  TIME_OFF_SINGLE_DAY_COLUMNS,
  TIME_OFF_COLUMNS,
  TIME_OFF_BE_KEYS,
  getTimeOffColumns
}
